//sets a value in redux store, used for card transitions
export default function dispatchTrueForOneSecond(dispatch, type) {
    dispatch({
        type,
        payload: true
    });

    setTimeout(() => {
        dispatch({
            type,
            payload: false
        });
    }, 1000);
}
